import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { useSyncQueryCache } from '../organizations_table/useSyncQueryCache'

const batchUpdateTasks = async tasks => {
  const url = `${baseUrl}/aws/tasks/gridbatch`

  try {
    const response = await axios.put(url, { tasks })
    return response.data
  } catch (error) {
    console.error('[batchUpdateTasks] API Error:', (error as any).response?.data || error.message)
    throw error
  }
}

export const useBatchUpdateTasks = () => {
  const queryClient = useQueryClient()
  const { syncTasksCacheAfterBatchUpdate, syncTaskEverywhere } = useSyncQueryCache()

  const mutation = useMutation({
    mutationFn: batchUpdateTasks,
    onMutate: async variables => {
      // Optimistically update the tasks cache
      await queryClient.cancelQueries({ queryKey: ['tasks_table'] })
      const previousTasks = queryClient.getQueryData(['tasks_table'])

      // Apply optimistic updates
      if (Array.isArray(variables)) {
        variables.forEach(task => {
          if (task?.SK) {
            syncTaskEverywhere(queryClient, task)
          }
        })
      }

      return { previousTasks }
    },
    onSuccess: (_response, variables) => {
      // Sync cache with the updated tasks
      if (Array.isArray(variables) && variables.length > 0) {
        syncTasksCacheAfterBatchUpdate(queryClient, variables)
        console.log(`[useBatchUpdateTasks] Synced ${variables.length} tasks to cache`)
      }
    },
    onError: (error, _variables, context) => {
      // Rollback on error
      if (context?.previousTasks) {
        queryClient.setQueryData(['tasks_table'], context.previousTasks)
      }
      console.error('[useBatchUpdateTasks] API Error:', (error as any).response?.data || error.message)
    },
  })

  return mutation
}
